<div class="text-surface-900 dark:text-surface-0 p-4 font-medium text-3xl mb-8">
    Temel Ürün Ayarları
</div>

<div class="grid grid-cols-12 gap-4 -mr-4 -ml-4 mt-2 lg:mt-0">
  <div class="col-span-12 px-0 lg:p-4">
    <div class="px-0 py-6 lg:px-6 bg-surface-0 dark:bg-surface-800 rounded-border shadow">
<div class="p-6">
    @if (providerProduct && product && providerSettings) {
        <div class=" grid grid-cols-12 gap-4  ">
            <div class="mb-4 col-span-12 lg:col-span-9">
                <label for="name" class="m-form-label">Ürün Adı</label>
              <small id="Name-help" class="text-red-500">
                @if (providerProduct.validation.Name.status || providerProductName.invalid && (providerProductName.dirty || providerProductName.touched)) {
                  {{providerProduct.validation.Name.Message}}
                }
              </small>
                <input
                  class="w-full"
                        [ngModel]="providerProduct.getName()" (ngModelChange)="nameChange($event);validation()"
                        [disabled]="providerProduct.UseProductName " #providerProductName="ngModel" id="name"
                        [ngClass]="'ng-invalid ng-dirty'" type="text" required pInputText>
            </div>
            <div class="mb-4 col-span-12 lg:col-span-3">
                <label for="UseProductName" class="font-medium flex justify-center">Ana ürünün ismini
                    kullan</label>
                <div id="UseProductName" class="flex items-center justify-center">
                    <p-toggleswitch
                            [ngModel]="providerProduct.UseProductName"
                            (ngModelChange)="providerProduct.setUseProductName();validation()"
                            inputId="UseProductName"></p-toggleswitch>
                </div>
            </div>
        </div>
      @if(!providerProduct.BuyboxIsActive){
      @if(providerSettings.currency.supporting){
            <p-divider align="left" type="solid">
                <b>Para Birimi</b>
            </p-divider>

            <div class="grid grid-cols-12 gap-4  ">

              <div class="mb-4 col-span-12">
                <div class="!text-center py-4 px-12">
                  <span>
                             @if (providerProduct.CurrencySupport) {

                               @if( providerProduct.Currency === product.Price.Currency) {
                                 <span class="text-red-500 text-lg font-bold">*</span>
                                 Döviz desteği seçilmiştir. <span
                                   class="font-bold">{{ providerProduct.Currency | currencyMagenty }}</span>  döviz birimi ile entegrasyon yapılacaktır.
                               }@else{

                                 <span class="text-red-500 text-lg font-bold">*</span>
                                 Döviz tipi <span class="font-bold">{{ product.Price.Currency | currencyMagenty }}</span> olan ürününüz, güncel kur(<span class="font-bold">{{providerProduct.Currency | currencyAmount}}</span>) üzerinden <span class="font-bold">{{ (providerProduct.Currency ) | currencyMagenty }}</span> cinsine dönüştürülerek pazaryerine aktarılacaktır.
                                 <a class="font-bold" href="/panel-settings/currency" target="_blank">tıklayınız</a>.
                               }
                             }
                            @else {
                              @if( providerProduct.Currency !== product.Price.Currency)
                                {  <span class="text-red-500 text-lg font-bold">*</span>
                              Döviz tipi <span class="font-bold">{{ product.Price.Currency | currencyMagenty }}</span> olan ürününüz, güncel kur(<span class="font-bold">{{product.Price.Currency | currencyAmount}}</span>) üzerinden <span class="font-bold">{{ (storeService.store$().panelSettings.defaultCurrency) | currencyMagenty }}</span> cinsine dönüştürülerek pazaryerine aktarılacaktır.
                                Panel ayarlarından mevcut döviz kurunu değiştirmek için lütfen
                                <a class="font-bold" href="/panel-settings/currency" target="_blank">tıklayınız</a>.
                                }

                            }

                          </span>
                </div>

              </div>
              <div class="mb-4 col-span-12 md:col-span-6">
                    <label for="CurrencySupport" class="m-form-label flex justify-center">Döviz Desteği</label>


                    <div id="CurrencySupport" class="flex items-center justify-center mt-2">
                      @if(providerSettings.currency.supporting){
                        <p-toggleswitch
                                (ngModelChange)="validation();providerProduct.Currency=product.Price.Currency" [(ngModel)]="providerProduct.CurrencySupport"
                                inputId="CurrencySupport"></p-toggleswitch>
                        <span class="ml-2">
                    {{providerProduct.CurrencySupport ? 'Evet':'Hayır'}}
                        </span>

                      }@else{
                          <span>Yok</span>

                      }
                    </div>

                </div>
                <div class="mb-4 col-span-12 md:col-span-6" [ngClass]="!providerProduct.CurrencySupport ? '!text-center':''">
                    <label for="currencyFields11" class="m-form-label">Para birimi</label>
                  @if(providerProduct.CurrencySupport){

                    <p-select
                      class="w-full"
                            (ngModelChange)="validation()" inputId="currencyFields" id="currencyFields11"
                            [disabled]="!providerProduct.CurrencySupport" appendTo="body"
                            [(ngModel)]="providerProduct.Currency" [options]="store?.panelSettings!.currencyFields"
                            optionLabel="header" optionValue="field" placeholder="Para birimi seçiniz"></p-select>
                  } @else {
                    <span class="block text-lg">
                      {{storeService.store$().panelSettings.defaultCurrency | currencyMagenty }}</span>

                  }
                </div>



            </div>

      }@else{
        @if (product.Price.Currency !== providerSettings.currency.supportedCurrency) {

          <p-divider align="left" type="solid">
            <b>Para Birimi</b>
          </p-divider>
        <div class="grid grid-cols-12 gap-4  ">

          <div class="mb-4 col-span-12">
            <div class="!text-center py-4 px-12">
                  <span>
                              <span class="text-red-500 text-lg font-bold">*</span>
                    Döviz tipi <span class="font-bold">{{ product.Price.Currency | currencyMagenty }}</span> olan ürününüz, güncel kur(<span class="font-bold">{{currencyRate}}</span>) üzerinden <span class="font-bold">{{ providerSettings.currency.supportedCurrency | currencyMagenty }}</span> cinsine dönüştürülerek pazaryerine aktarılacaktır.

                          </span>
            </div>

          </div>
          <div class="mb-4 col-span-12 md:col-span-6">
            <label for="CurrencySupport" class="font-medium flex justify-center">Döviz Desteği</label>


            <div id="CurrencySupport2" class="flex items-center justify-center">

              <span>Yok</span>


            </div>

          </div>
          <div class="mb-4 col-span-12 md:col-span-6 !text-center">
            <label for="currencyFields11" class="m-form-label">Para birimi</label>

              <span class="block text-lg">
                      {{providerSettings.currency.supportedCurrency | currencyMagenty }}</span>


          </div>


        </div>
        }
      }
      }

        <p-divider align="left" type="solid">
            <b>Fiyat İşlemleri</b>
        </p-divider>
      @if(providerProduct.BuyboxIsActive){
        <div class="my-4">
          <p-message [icon]="'pi pi-info-circle'" severity="info">Ürünleriniz arasında <strong>Buybox özelliği aktif olan ürünler</strong> bulunuyor. Bu ürünleri kolayca yönetmek ve rekabette öne çıkmak için <strong>Buybox ekranını</strong> kullanabilirsiniz. Hemen inceleyin ve satış performansınızı artırın!</p-message>
        </div>
      }
      @if(!providerProduct.BuyboxIsActive  || (providerProduct.BuyboxIsActive && providerProduct?.oldPriceSource === PriceSourceEnum.ManualPrice)){
        <div class="grid grid-cols-12 gap-4  ">
          <div class="mb-4 col-span-12 ">
            <label for="price-help" class="m-form-label">Fiyat Kaynağı</label>
            <small id="price-help" class="text-red-500 ">

              @if (providerProduct.validation.Price.status) {
                *{{ providerProduct.validation.Price.Message }}
              }
            </small>

            <p-select
              class="w-full"
              (ngModelChange)="validation();providerProduct.getSellPrice()" inputId="PriceSource" id="PriceSource"
              appendTo="body"
              [(ngModel)]="providerProduct.PriceSource" [options]="priceSourceConst" optionLabel="header"
              optionValue="field" placeholder="Fiyat Kaynağını Seçiniz"></p-select>
          </div>
        </div>

        @if (providerProduct.PriceSource === PriceSourceEnum.BasePrice) {
          <p-divider align="center" type="solid">
            <b>Temel Fiyat İşlemi</b>
          </p-divider>
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 xl:col-span-5 flex justify-center items-center">
              <div style="max-width:1200px" class="w-full">
                <div class="xl:flex xl:items-center xl:justify-between xl:gap-1">
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    <label for="UseProductName" class="font-medium xl:block xl:mb-1">Yüzdelik
                      Kullan</label>
                    <div id="SellPriceChangeIsPercent" class="flex items-center justify-center xl:mt-4">
                      <p-toggleswitch
                        (ngModelChange)="validation()"
                        [(ngModel)]="providerProduct.SellPriceChangeIsPercent" [trueValue]="1"
                        [falseValue]="0" inputId="SellPriceChangeIsPercent"></p-toggleswitch>
                    </div>
                  </div>
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    <label for="currencyFields12" class="font-medium xl:block xl:mb-1">İşlem Türü</label>
                    <p-select
                      (ngModelChange)="validation()" inputId="currencyFields" id="currencyFields12"
                      appendTo="body" [(ngModel)]="providerProduct.SellIncreaseDecreaseType"
                      [options]="providerProductIncrementTypeOptions" optionLabel="header"
                      optionValue="field" placeholder="Para birimi seçiniz"></p-select>
                  </div>
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    @if (providerProduct.SellPriceChangeIsPercent === PercentageTypeEnum.Yes) {
                      <label for="SellPriceChangeValue0" class="font-medium xl:block xl:mb-1">
                        Yüzdelik {{ providerProduct.SellIncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                      <p-inputNumber
                        [allowEmpty]="false"
                        (ngModelChange)="validation()" [size]="'large'" [min]="0" id="SellPriceChangeValue0"
                        prefix="%" [(ngModel)]="providerProduct.SellPriceChangeValue" mode="decimal"
                        [showButtons]="true" inputId="minmax-buttons" [max]="100"></p-inputNumber>
                    } @else {
                      <label for="SellPriceChangeValue" class="font-medium xl:block xl:mb-1">
                        Miktar {{ providerProduct.SellIncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                      <p-inputNumber
                        [allowEmpty]="false"
                        (ngModelChange)="validation()" [size]="'large'" [min]="0" id="SellPriceChangeValue"
                        [(ngModel)]="providerProduct.SellPriceChangeValue" [showButtons]="true"
                        inputId="stacked" mode="currency"

                        [currency]="product.Price.Currency|currencyMagenty"></p-inputNumber>
                    }
                  </div>
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    <label for="sellpriceclear0" class="font-medium xl:block xl:mb-1">Sıfırla</label>
                    <p-button
                      id="sellpriceclear0" icon="pi pi-times" (onClick)="sellPriceClear()"
                      [rounded]="true" [text]="true" severity="danger"></p-button>
                  </div>
                </div>

                @if (!isVariantTable) {

                  <div class="flex flex-col lg:flex-row flex-wrap justify-between  p-6 px-0 ">
                    <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                      <p class="font-medium !text-center">
                        Temel Satış Fiyatı </p>
                      @if (product.IsVariant && !providerSettings.Variant.supporting && product.VariantItemPriceType === VariantItemPriceTypeEnum.PriceDifference
                      && (providerProduct.VariantCode | providerProductFindVariantItem: product)?.IncrementType === VariantIncrementTypeEnum.Fixed) {
                        <tui-money
                          [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                          [value]="product.Price.SellPrice"
                          class="text-muted-color line-through"></tui-money>
                      } @else {
                        <tui-money
                          [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                          [value]="product.Price.SellPrice" class="text-muted-color"></tui-money>
                      }
                    </div>
                    @if (product.IsVariant && product.VariantItemPriceType === VariantItemPriceTypeEnum.PriceDifference && !providerSettings.Variant.supporting) {
                      <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                        <p class="font-medium !text-center">
                          Variant Fiyatı </p>
                        @if ((providerProduct.VariantCode | providerProductFindVariantItem: product)?.IncrementType === VariantIncrementTypeEnum.Down) {
                          -
                        } @else if ((providerProduct.VariantCode | providerProductFindVariantItem: product)?.IncrementType === VariantIncrementTypeEnum.Up) {
                          +
                        }
                        {{ (providerProduct.VariantCode | providerProductFindVariantItem: product)?.PriceAmount }}
                      </div>
                    }

                    <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                      @if (providerProduct.SellPriceChangeIsPercent === PercentageTypeEnum.Yes) {
                        <p class="font-medium !text-center">Temel Fiyata Eklenen
                          Oran</p>%{{ providerProduct.SellPriceChangeValue }}
                      } @else {
                        <p class="font-medium !text-center">
                          Temel Fiyata Eklenen Tutar </p>
                        <tui-money
                          [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                          [value]="providerProduct.SellPriceChangeValue"
                          class="text-muted-color"></tui-money>
                      }
                    </div>
                    <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                      <p class="font-medium !text-center">
                        Temel Fiyata Sonuç </p>
                      <tui-money
                        [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                        [value]="providerProduct.getSellPrice()" class="text-muted-color"></tui-money>
                    </div>
                  </div>
                }

              </div>
            </div>
            <div class=" col-span-12 xl:col-span-2 flex justify-center items-center">
              <div class=" hidden xl:block h-full">
                <div class="flex relative items-center justify-center mx-4 py-4 min-h-full">
                  <div class="border-l border-surface top-0 left-1/2 absolute h-full"></div>
                  <div class="py-2 z-10 bg-surface-0 dark:bg-surface-800">
                    <span class="text-surface-900 dark:text-surface-0 font-medium">Sonuç</span>
                  </div>
                </div>
              </div>
              <p-divider class="xl:!hidden w-full"></p-divider>
            </div>
            <div class="col-span-12 xl:col-span-5 flex justify-center items-center">
              <div style="max-width:1200px" class="w-full">
                <div class="xl:flex xl:items-center xl:justify-between xl:gap-1">
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    <label for="UseProductName" class="font-medium xl:block xl:mb-1r">Yüzdelik
                      Kullan</label>
                    <div
                      id="StrikeThroughPriceChangeIsPercent"
                      class="flex items-center justify-center xl:mt-4">
                      <p-toggleswitch
                        (ngModelChange)="validation()"
                        [(ngModel)]="providerProduct.StrikeThroughPriceChangeIsPercent" [trueValue]="1"
                        [falseValue]="0" inputId="SellPriceChangeIsPercent"></p-toggleswitch>
                    </div>
                  </div>
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    <label for="currencyFields13" class="font-medium xl:block xl:mb-1">İşlem Türü</label>
                    <p-select
                      (ngModelChange)="validation()" inputId="currencyFields" id="currencyFields13"
                      appendTo="body" [(ngModel)]="providerProduct.StrikeThroughIncreaseDecreaseType"
                      [options]="providerProductIncrementTypeOptions" optionLabel="header"
                      optionValue="field" placeholder="Artış Tipini Seçiniz"></p-select>
                  </div>
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    @if (providerProduct.StrikeThroughPriceChangeIsPercent === PercentageTypeEnum.Yes) {
                      <label for="StrikeThroughPriceChangeValue" class="font-medium xl:block xl:mb-1">
                        Yüzdelik {{ providerProduct.StrikeThroughIncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                      <p-inputNumber
                        [allowEmpty]="false"
                        (ngModelChange)="validation()" prefix="%"
                        [(ngModel)]="providerProduct.StrikeThroughPriceChangeValue" mode="decimal"
                        [showButtons]="true" inputId="minmax-buttons" [min]="0" [size]="'large'"
                        [max]="100"></p-inputNumber>
                    } @else {
                      <label for="StrikeThroughPriceChangeValue" class="font-medium xl:block xl:mb-1">
                        Miktar {{ providerProduct.StrikeThroughIncreaseDecreaseType === ProviderProductIncrementTypeEnum.Up ? 'Artış' : 'Azalış' }}</label>
                      <p-inputNumber
                        [allowEmpty]="false"
                        (ngModelChange)="validation()" [size]="'large'" [min]="0"
                        id="StrikeThroughPriceChangeValue"
                        [(ngModel)]="providerProduct.StrikeThroughPriceChangeValue" [showButtons]="true"
                        inputId="stacked" mode="currency"
                        [currency]="product.Price.Currency|currencyMagenty"></p-inputNumber>
                    }
                  </div>
                  <div class="flex justify-between mb-2 xl:mb-0 xl:inline-block ">
                    <label for="strikeThroughPriceClear0" class="font-medium xl:block xl:mb-1">Sıfırla</label>
                    <p-button
                      id="strikeThroughPriceClear0" icon="pi pi-times" [rounded]="true"
                      (onClick)="strikeThroughPriceClear()" [text]="true" severity="danger"></p-button>
                  </div>
                </div>
                @if (!isVariantTable) {
                  <div class="flex flex-col   lg:flex-row  lg:justify-between p-6 px-0">
                    <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                      <p class="font-medium !text-center">
                        Üstü Çizili Fiyat </p>
                      <tui-money
                        [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                        [value]="product.Price.StrikeThroughPrice" class="text-muted-color"></tui-money>
                    </div>

                    @if (product.IsVariant && product.VariantItemPriceType === VariantItemPriceTypeEnum.PriceDifference && !providerSettings.Variant.supporting) {
                      <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                        <p class="font-medium !text-center">
                          Variant Oranı </p>
                        <tui-money
                          [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                          [value]="(providerProduct.getStrikeThroughPrice() - product.Price.StrikeThroughPrice)"
                          class="text-muted-color"></tui-money>
                      </div>
                    }

                    <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                      @if (providerProduct.StrikeThroughPriceChangeIsPercent === PercentageTypeEnum.Yes) {
                        <p class="font-medium !text-center">
                          Üstü Çiziliye Eklenen Oran </p>%{{ providerProduct.StrikeThroughPriceChangeValue }}
                      } @else {
                        <p class="font-medium !text-center">
                          Üstü Çiziliye Eklenen Tutar </p>
                        <tui-money
                          [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                          [value]="providerProduct.StrikeThroughPriceChangeValue"
                          class="text-muted-color"></tui-money>
                      }
                    </div>
                    <div class="flex flex-row justify-between lg:flex-col  px-1 items-center lg:justify-center">
                      <p class="font-medium !text-center">
                        Üstü Çizili Sonuç </p>
                      <tui-money
                        [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                        [value]="providerProduct.getStrikeThroughPrice()"
                        class="text-muted-color"></tui-money>
                    </div>
                  </div>
                }

              </div>
            </div>


          </div>
        } @else if (providerProduct.PriceSource === PriceSourceEnum.PriceTemplate) {
          <p-divider align="center" type="solid">
            <b>Fiyat Şablonu</b>
          </p-divider>


          <div class="grid grid-cols-12 ">
            <div
              [ngClass]="isVariantTable ? 'col-span-12':'col-span-5 py-8'"
              class=" !text-center flex items-center justify-center"
            >
              <div class="flex flex-col grow px-1 items-center justify-center">

                @if (priceTemplateOptions.length === 0) {

                  <button pButton [label]="'Fiyat Şablonu Ekle'"
                          (click)="addAndUpdatePriceTemplateOpenModal(undefined)"></button>
                } @else {
                  <label for="PriceTemplateId" class="m-form-label" [hidden]="isVariantTable">Fiyat Şablonu</label>
                  <p-select
                    class=" w-10"
                    styleClass="w-full"
                    (ngModelChange)="validation()" inputId="currencyFields" id="PriceTemplateId"
                    appendTo="body" [(ngModel)]="providerProduct.PriceTemplateId"
                    [options]="priceTemplateOptions" optionLabel="header" optionValue="field"
                    placeholder="Fiyat Şablonu Seçiniz"></p-select>
                }
              </div>
            </div>
            @if (!isVariantTable) {

              <div class="col-span-2">
                <div class="flex relative items-center justify-center mx-4 py-4 min-h-full">
                  <div class="border-l border-surface top-0 left-1/2 absolute h-full"></div>
                  <div class="py-2 z-10 bg-surface-0 dark:bg-surface-800">
                    <span class="text-surface-900 dark:text-surface-0 font-medium">Sonuç</span>
                  </div>
                </div>
              </div>
              <div class="col-span-5 py-20 ">
                <div class="flex flex-col md:flex-row  p-6 ">
                  <div class="flex flex-col grow px-1 items-center justify-center">
                    <p class="font-medium">
                      Temel Satış Fiyatı </p>
                    @if (product.IsVariant && !providerSettings.Variant.supporting && product.VariantItemPriceType === VariantItemPriceTypeEnum.PriceDifference
                    && (providerProduct.VariantCode | providerProductFindVariantItem: product)?.IncrementType === VariantIncrementTypeEnum.Fixed) {
                      <tui-money
                        [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                        [value]="product.Price.SellPrice"
                        class="text-muted-color line-through"></tui-money>
                    } @else {
                      <tui-money
                        [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                        [value]="product.Price.SellPrice" class="text-muted-color"></tui-money>
                    }
                  </div>
                  <div class="flex flex-col grow px-1 items-center justify-center">
                    <p class="font-medium">
                      Temel Fiyata Sonuç </p>
                    <tui-money
                      [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                      [value]="providerProduct.getSellPrice()" class="text-muted-color"></tui-money>
                  </div>
                </div>
                <div
                  class="flex flex-col   md:flex-row  p-6">
                  <div class="flex  flex-col grow px-1 items-center justify-center">
                    <p class="font-medium">
                      Üstü Çizili Fiyat </p>
                    <tui-money
                      [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                      [value]="product.Price.StrikeThroughPrice" class="text-muted-color"></tui-money>
                  </div>
                  <div class="flex flex-col grow px-1 items-center justify-center">
                    <p class="font-medium">
                      Üstü Çizili Sonuç </p>
                    <tui-money
                      [colored]="true" [currency]="product.Price.Currency|currencyMagenty"
                      [value]="providerProduct.getStrikeThroughPrice()"
                      class="text-muted-color"></tui-money>
                  </div>
                </div>
              </div>
            }
          </div>


        } @else {
          <div class="flex flex-col md:flex-row py-4 xl:p-6 mb-6 gap-2">
            <div class="flex xl:flex-col grow px-1 items-center xl:justify-center justify-between">
              <label for="SellPrice" class="m-form-label"> Satış Fiyatı </label>
              <p-inputNumber
                [allowEmpty]="false"
                inputStyleClass="w-40 xl:w-auto"
                (ngModelChange)="validation()" id="SellPrice" [(ngModel)]="providerProduct.SellPrice"
                [showButtons]="true" inputId="stacked" mode="currency" [min]="0"
                [currency]="product.Price.Currency|currencyMagenty"></p-inputNumber>
            </div>
            <div class="flex xl:flex-col grow px-1 items-center xl:justify-center justify-between">
              <label for="StrikeThroughPrice" class="m-form-label"> Üstü Çizili Fiyat </label>
              <p-inputNumber
                [allowEmpty]="false"
                inputStyleClass="w-40 xl:w-auto"
                (ngModelChange)="validation()" [min]="0" id="StrikeThroughPrice"
                [(ngModel)]="providerProduct.StrikeThroughPrice" [showButtons]="true" inputId="stacked"
                mode="currency" [currency]="product.Price.Currency|currencyMagenty"></p-inputNumber>
            </div>
          </div>
        }
      }
    }
</div>
      @if(isVariantTable && !providerProduct?.BuyboxIsActive && providerProduct?.PriceSource === PriceSourceEnum.ManualPrice){

        <div class="flex bg-white dark:bg-surface-900 p-1 mt-6">

          <p-table
            [selectionMode]="'multiple'"
            class="w-full"
            [value]="productVariantList"
            responsiveLayout="stack"
            breakpoint="992px"
            stripedRows
            styleClass="lg:p-datatable-sm border border-surface  lg:border-0"
            [tableStyle]="{'min-width': '18rem'}">
            <ng-template #header>
              <tr>
                <th class="!text-center" >Varyant Adı</th>
                @if(providerProduct.PriceSource!==PriceSourceEnum.ManualPrice){
                  <th class="!text-center">Varyant Fiyat Tipi</th>
                  <th class="!text-center">Temel Satış Fiyatı</th>
                <th  class="!text-center">Varyant Fiyatı</th>

                <th class="!text-center">Temel Fiyata Eklenen Tutar</th>
                }
                <th class="!text-center">Temel Fiyatı Sonuç</th>
                <th></th>
                @if(providerProduct.PriceSource!==PriceSourceEnum.ManualPrice){
                <th class="!text-center">Temel Üstü Çizili Fiyatı</th>
                <th class="!text-center">Temel Üstü Çizili Fiyata Eklenen Tutar</th>
                }
                <th class="!text-center">Temel Üstü Çizili Fiyatı Sonuç</th>



              </tr>
            </ng-template>
            <ng-template #body let-variantItem >
              <tr [pTooltip]="'Varyant Kodu: '+variantItem.Code " tooltipPosition="top">
                <td style="text-wrap: nowrap" class="!text-center">
                  <span class="p-column-title font-bold">Varyant Adı</span>
                 <span >{{variantItem.Name}}</span>
                </td>
                @if(providerProduct.PriceSource!==PriceSourceEnum.ManualPrice){
                  <td class="!text-center">
                    <span class="p-column-title font-bold">Varyant Fiyat Artışı</span>
                      <span>{{variantItem.IncrementType | variantItemIncrementType}}</span>

                  </td>
                  <td class="!text-center">
                    <span class="p-column-title font-bold">Temel Satış Fiyatı</span>
                    @if(variantItem.IncrementType!==VariantIncrementTypeEnum.Fixed){

                    <tui-money
                      [colored]="true" [currency]="product.Price.Currency| currencyMagenty" [value]="product.Price.SellPrice"
                    ></tui-money>
                    }
                  </td>

                <td  class="cursor-pointer !text-center">
                  <span class="p-column-title font-bold">Varyant Fiyatı</span>
                  @if(variantItem.IncrementType===VariantIncrementTypeEnum.Fixed){
                    <tui-money
                      [colored]="true" [currency]="product.Price.Currency| currencyMagenty" [value]="variantItem.PriceAmount"
                      class="text-primary-700"></tui-money>
                  }
                  @else{
                    <tui-money
                      [colored]="true" [currency]="product.Price.Currency| currencyMagenty" [sign]="variantItem.IncrementType === VariantIncrementTypeEnum.Up ? 'force-positive':'force-negative'" [value]="variantItem.PriceAmount"
                      class="text-primary-700"></tui-money>
                  }


                </td>

                <td class="!text-center">
                  <span class="p-column-title font-bold">Temel Fiyata Eklenen Tutar</span>

                  @if(providerProduct.SellPriceChangeIsPercent){

                  <tui-money
                    [currency]="''"
                    [sign]="providerProduct.SellIncreaseDecreaseType === 0 ? 'force-positive':'force-negative'"
                    [colored]="true"   [value]="providerProduct.SellPriceChangeValue "
                  ></tui-money>
                    <span class="ml-1 opacity-60" [style.color]="providerProduct.SellIncreaseDecreaseType===0 ? '#3aa981':'#dd4c1e'">%</span>
                  }
                  @else{
                    <tui-money
                      [sign]="providerProduct.SellIncreaseDecreaseType === 0 ? 'force-positive':'force-negative'"
                      [colored]="true" [currency]="product.Price.Currency| currencyMagenty"   [value]="providerProduct.SellPriceChangeValue "
                    ></tui-money>
                  }


                </td>
                }
                <td class="!text-center">
                  <span class="p-column-title font-bold">Temel Fiyat Sonuç</span>
                  <tui-money
                    class="font-bold"
                    [colored]="true" [currency]="product.Price.Currency| currencyMagenty"
                    [value]=" providerProduct.getSellPrice(variantItem.Code)"
                  ></tui-money>

                </td>

                <td class="!text-center">
                  <div style="max-height:60px" class="hidden lg:block" >
                    |
                  </div>
                  <div class="lg:hidden w-full" >
                    <p-divider layout="horizontal"  />
                  </div>

                </td>


                @if(providerProduct.PriceSource!==PriceSourceEnum.ManualPrice){
                <td class="!text-center">
                  <span class="p-column-title font-bold">Temel Üstü Çizili Fiyatı</span>


                  <tui-money
                    [colored]="true" [currency]="product.Price.Currency| currencyMagenty" [value]="product.Price.StrikeThroughPrice "
                  ></tui-money>

                </td>
                <td class="!text-center">
                  <span class="p-column-title font-bold">Temel Üstü Çizili Fiyata Eklenen Tutar</span>
                  @if(providerProduct.StrikeThroughPriceChangeIsPercent){

                    <tui-money
                      [currency]="''"
                      [sign]="providerProduct.StrikeThroughIncreaseDecreaseType === 0 ? 'force-positive':'force-negative'"
                      [colored]="true"   [value]="providerProduct.StrikeThroughPriceChangeValue "
                    ></tui-money>
                    <span class="ml-1 opacity-60" [style.color]="providerProduct.StrikeThroughIncreaseDecreaseType===0 ? '#3aa981':'#dd4c1e'">%</span>

                  }
                  @else{
                    <tui-money
                      [sign]="providerProduct.StrikeThroughIncreaseDecreaseType === 0 ? 'force-positive':'force-negative'"
                      [colored]="true"  [currency]="product.Price.Currency| currencyMagenty"  [value]="providerProduct.StrikeThroughPriceChangeValue "
                    ></tui-money>
                  }


                </td>
                }
                <td class="!text-center">
                  <span class="p-column-title font-bold">Temel Üstü Çizili Fiyat Sonuç</span>
                  <tui-money
                    class="font-bold"
                    [colored]="true" [currency]="product.Price.Currency| currencyMagenty"
                    [value]=" providerProduct.getStrikeThroughPrice(variantItem.Code)"
                  ></tui-money>

                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
  </div>
</div>




